package com.lomdaat.ads.internal.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import nl.adaptivity.xmlutil.serialization.XmlElement
import nl.adaptivity.xmlutil.serialization.XmlSerialName
import nl.adaptivity.xmlutil.serialization.XmlValue

@Serializable
@XmlSerialName("VAST")
internal data class VastXml(
    @XmlElement(true) @XmlSerialName("Ad") val ad: VastAdXml? = null,
)

@Serializable
internal data class VastAdXml(
    @XmlElement(true) @XmlSerialName("InLine") val inLine: VastInLineXml? = null,
)

@Serializable
internal data class VastInLineXml(
    @XmlElement(true) @XmlSerialName("Impression") val impression: VastCdataXml? = null,
    @XmlElement(true) @XmlSerialName("Creatives") val creatives: VastCreativesXml? = null,
)

@Serializable
internal data class VastCreativesXml(
    @XmlElement(true) @XmlSerialName("Creative") val creatives: List<VastCreativeXml> = emptyList(),
)

@Serializable
internal data class VastCreativeXml(
    @XmlElement(true) @XmlSerialName("Linear") val linear: VastLinearXml? = null,
)

@Serializable
internal data class VastLinearXml(
    @SerialName("skipoffset") val skipOffset: String? = null,
    @XmlElement(true) @XmlSerialName("Duration") val duration: String? = null,
    @XmlElement(true) @XmlSerialName("VideoClicks") val videoClicks: VastVideoClicksXml? = null,
    @XmlElement(true) @XmlSerialName("MediaFiles") val mediaFiles: VastMediaFilesXml? = null,
)

@Serializable
internal data class VastVideoClicksXml(
    @XmlElement(true) @XmlSerialName("ClickThrough") val clickThrough: VastCdataXml? = null,
    @XmlElement(true) @XmlSerialName("ClickTracking") val clickTracking: VastCdataXml? = null,
)

@Serializable
internal data class VastMediaFilesXml(
    @XmlElement(true) @XmlSerialName("MediaFile") val mediaFiles: List<VastMediaFileXml> = emptyList(),
)

@Serializable
internal data class VastMediaFileXml(
    @SerialName("type") val type: String? = null,
    @SerialName("width") val width: String? = null,
    @SerialName("height") val height: String? = null,
    @XmlValue val url: String = "",
)

@Serializable
internal data class VastCdataXml(
    @XmlValue val value: String = "",
)
